import React from 'react'
import { Route, Routes } from "react-router-dom"
import SettingListScreen from "screens/App/CRM/Setting/SettingListScreen"

const SettingRouter = () => {
  return (
      <Routes>
          <Route path="list" element={<SettingListScreen />} />

      </Routes>
  )
}

export default SettingRouter